module.exports = __webpack_public_path__ + "static/media/seyrah4x.edf15e7f.png";